import { FilterConfigBuilder } from '@juvare/common-data-table-ui/FiltersBar/utils';
import { WidgetFormPanelConfig } from '@juvare/common-form-ui/WidgetFormPanel';
import { AccountFilterData } from '@juvare/contact-management/ui/features/accounts/hooks/useAccountList';
import React from 'react';
import { useTranslation } from 'react-i18next';

export function useExtendedRmsUserDirectoryFilters() {
    const { t } = useTranslation('rms');

    const extendRmsFilters = React.useCallback(
        (builder: FilterConfigBuilder<AccountFilterData>) => {
            const locationPanel = builder.findAllFiltersWidget('!location') as WidgetFormPanelConfig;
            locationPanel.children.push(
                builder.allFiltersWidget({
                    label: t('accountsFilters.location.stateOfWorksLabel'),
                    type: 'form.select',
                    key: 'stateOfWork',
                    valueProvider: {
                        type: 'classifier.state',
                    },
                }),
            );
        },
        [t],
    );

    return { extendRmsFilters };
}
